var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcoFuncaoMultiplicacao01(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 36 36",
    style: {
      enableBackground: "new 0 0 36 36"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "multiplica\\xE7\\xE3o",
    transform: "translate(173.688 706.205)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "multiplication",
    transform: "translate(166.312 168.794)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1259",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1258",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_745",
    d: "M-305.1-842.9l-31-31c-0.8-0.8-2-0.8-2.8,0c-0.8,0.8-0.8,2,0,2.8c0,0,0,0,0,0l31,31 c0.8,0.8,2,0.8,2.8,0C-304.3-840.8-304.3-842.1-305.1-842.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_748",
    d: "M-338.9-842.9l31-31c0.8-0.8,2-0.8,2.8,0c0.8,0.8,0.8,2,0,2.8c0,0,0,0,0,0l-31,31 c-0.8,0.8-2,0.8-2.8,0S-339.7-842.1-338.9-842.9z"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoFuncaoMultiplicacao01);
export default __webpack_public_path__ + "static/media/ico-funcao-multiplicacao-01.18113ccd2235793ac26f353aec7f11c9.svg";
export { ForwardRef as ReactComponent };